import {baseUrl} from '../config';

// Construct full endpoint URL
export const constructUrl = (endpoint) => `${baseUrl}${endpoint}`;
